<div class="header">
    <mat-icon class="material-icons-outlined">{{ icon }}</mat-icon>
    <h2>{{ title }}</h2>
</div>
